import type { SupportedLocale } from '../hooks/useLocale';

// Tiny imperative store for the full-screen "Switching to <language>…" overlay
// shown while a locale change triggers a native RTL reload. `changeLocale` flips
// this on just before it tears down the JS runtime (see useLocale.ts); the
// root-mounted <LocaleSwitchOverlay /> subscribes and paints the branded screen
// so the user sees an intentional transition instead of a bare black flash.
// It never needs to be hidden from JS: the reload unmounts everything and the
// fresh boot renders in the new locale.

export type LocaleSwitchState = {
  active: boolean;
  target: SupportedLocale | null;
};

let state: LocaleSwitchState = { active: false, target: null };
const listeners = new Set<() => void>();

export function getLocaleSwitchState(): LocaleSwitchState {
  return state;
}

export function subscribeLocaleSwitch(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function showLocaleSwitchOverlay(target: SupportedLocale) {
  state = { active: true, target };
  listeners.forEach((listener) => listener());
}

export function hideLocaleSwitchOverlay() {
  if (!state.active) return;
  state = { active: false, target: null };
  listeners.forEach((listener) => listener());
}
